import { RequestInstance } from "../../../utils/request";

export const contractPage = new RequestInstance({
  method: "get",
  url: "/v2/contract/page",
});

export const contractUpdate = new RequestInstance({
  method: "post",
  url: "/v2/contract/update",
});

export const contractStatistics = new RequestInstance({
  method: "get",
  url: "/v2/contract/statistics",
});

export const tenantPage = new RequestInstance({
  method: "get",
  url: "/v2/tenant/page",
});

export const tenantAdd = new RequestInstance({
  method: "post",
  url: "/v2/tenant/add",
});

export const estateList = new RequestInstance({
  method: "get",
  url: "/v2/estate/list",
});

export const floorList = new RequestInstance({
  method: "get",
  url: "/v2/floor/list",
});

export const roomList = new RequestInstance({
  method: "get",
  url: "/v2/room/list",
});

export const roomDeviceList = new RequestInstance({
  method: "get",
  url: "/v2/room/device/list",
});

export const contractAdd = new RequestInstance({
  method: "post",
  url: "/v2/contract/add",
});

export const contractDeviceAdd = new RequestInstance({
  method: "post",
  url: "/v2/contract/device/add",
});

export const contractDeviceList = new RequestInstance({
  method: "get",
  url: "/v2/contract/device/list",
});

export const contractDeviceRemove = new RequestInstance({
  method: "post",
  url: "/v2/contract/device/remove",
});

export const calculationAmount = new RequestInstance({
  method: "post",
  url: "/v2/contract/calculation/amount",
});

export const contractCancel = new RequestInstance({
  method: "post",
  url: "/v2/contract/cancel",
});

export const deviceRealTime = new RequestInstance({
  method: "get",
  url: "/v2/device/realtime",
});

export const deviceManualOperate = new RequestInstance({
  method: "post",
  url: "/v2/device/manual/operate",
});

export const fileInfoRemove = new RequestInstance({
  method: "post",
  url: "/v2/file/info/remove_by_id",
});

export const fileListResource = new RequestInstance({
  method: "get",
  url: "/v2/file/list/by/resource",
});
